<template>
    <van-popup v-model="popupVisible" position="bottom" @click-overlay="close">
        <div class="action-content" :class="whiteBg?'white-bg':''">
            <div class="boxs">
                <div
                        class="lists tips"
                        v-if="tips"
                >{{tips}}</div>
                <div
                        class="lists"
                        v-for="(list,index) in item"
                        :key="index"
                        @click="itemClick(list)"
                >{{list.title}}</div>
            </div>
            <div class="boxs" v-if="bottomShow">
                <div class="lists" @click="close">{{$t('edit.editMessage.cancelText')}}</div>
            </div>
        </div>
    </van-popup>
</template>

<script>
    import Vue from "vue";
    import {
        Popup,
    } from "vant";
    Vue.use(Popup);
    export default {
        name: "BottomTip",
        props:{
            visible:{
                type: Boolean,
                require: true
            },
            tips:{
                type: String,
                default:''
            },
            item:{
                type: Array,
                default: ()=>{}
            },
            bottomShow:{
                type: Boolean,
                default: true
            },
            whiteBg:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return{
                popupVisible: this.visible
            }
        },
        watch:{
            visible:{
                handler(newVal){
                    this.popupVisible = newVal
                }
            }
        },
        methods:{
            close(){
                this.$emit('close')
            },
            itemClick(list){
                this.$emit('itemClick',list.type)
            }
        }
    }
</script>

<style lang="less" scoped>
    .van-popup{
        background-color: transparent;
    }
    .action-content{
        padding: 0 8px;
        &.white-bg{
            .boxs{
                .lists{
                    background-color: #ffffff;
                    border-color: #efefef;
                }
            }
        }
        .boxs{
            border-radius: 10px;
            margin-bottom: 8px;
            overflow: hidden;
            .lists{
                background-color: #232323;
                height: 56px;
                line-height: 56px;
                text-align: center;
                font-size: 18px;
                color: #ffffff;
                border-bottom: 1px solid #000000;
                &:last-child{
                    border-bottom: 0;
                }
                &.tips{
                    font-size: 12px;
                    color: #727272;
                    line-height: normal;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 50px;
                }
            }
        }
    }
</style>
